import React from 'react'
import styled from 'styled-components'

import Introduction from './Introduction'
import Colour from './Colour'
import Images from './Images'
import Typography from './Typography'
import GridsAndLayout from './GridsAndLayout'
import Iconography from './Iconography'
import Buttons from './Buttons'
import FormElements from './FormElements'
import Lists from './Lists'
import Navigation from './Navigation'
import Stats from './Stats'
import Tables from './Tables'
import ContentHighlight from './ContentHighlight'
import Dropdown from './Dropdown'
import InsetText from './InsetText'
import Logo from './Logo'
import Notification from './Notification'
import CodeBlock from './CodeBlock'
import Tags from './Tags'
import Toggle from './Toggle'
import Textarea from './Textarea'
import Accordion from './Accordion'
import TextAndImage from './TextAndImage'
import Confirmation from './Confirmation'
import CallToAction from './CallToAction'
import VideoAndText from './VideoAndText'
import Carousel from './Carousel'
import TextIconAndImages from './TextIconAndImages'

const Content = styled.div`
  @media (min-width: ${(p) => p.theme.breakpointLg}) {
    width: 100%;
  }
`

const ChameleonContent = ({ currentSection, setCurrentSection }) => {
  return (
    <Content>
      {currentSection === 'Introduction' ? (
        <Introduction setCurrentSection={setCurrentSection} />
      ) : currentSection === 'Colour' ? (
        <Colour />
      ) : currentSection === 'Images' ? (
        <Images />
      ) : currentSection === 'Typography' ? (
        <Typography />
      ) : currentSection === 'Grids and layout' ? (
        <GridsAndLayout />
      ) : currentSection === 'Iconography' ? (
        <Iconography />
      ) : currentSection === 'Buttons' ? (
        <Buttons />
      ) : currentSection === 'Form elements' ? (
        <FormElements />
      ) : currentSection === 'Lists' ? (
        <Lists />
      ) : currentSection === 'Navigation' ? (
        <Navigation />
      ) : currentSection === 'Stats' ? (
        <Stats />
      ) : currentSection === 'Tables' ? (
        <Tables />
      ) : currentSection === 'Content highlight' ? (
        <ContentHighlight />
      ) : currentSection === 'Dropdown' ? (
        <Dropdown />
      ) : currentSection === 'Inset text' ? (
        <InsetText />
      ) : currentSection === 'Logo' ? (
        <Logo />
      ) : currentSection === 'Notification' ? (
        <Notification />
      ) : currentSection === 'Code block' ? (
        <CodeBlock />
      ) : currentSection === 'Tags' ? (
        <Tags />
      ) : currentSection === 'Toggle' ? (
        <Toggle />
      ) : currentSection === 'Text area' ? (
        <Textarea />
      ) : currentSection === 'Accordion' ? (
        <Accordion />
      ) : currentSection === 'Text and image' ? (
        <TextAndImage />
      ) : currentSection === 'Confirmation' ? (
        <Confirmation />
      ) : currentSection === 'Call to action' ? (
        <CallToAction />
      ) : currentSection === 'Video and text' ? (
        <VideoAndText />
      ) : currentSection === 'Carousel' ? (
        <Carousel />
      ) : currentSection === 'Text, icon and images' ? (
        <TextIconAndImages />
      ) : (
        <div>No Content</div>
      )}
    </Content>
  )
}

export default ChameleonContent
